export enum DOCUMENTS_LIST {
    /* Заявка об акцепте */
    ACCEPT_APPLICATION = 'accept-application',

    /* Доверенность */
    ATTORNEY_LETTER = 'attorney-letter',

    /* Оферта на заключение соглашения о взаимодействии */
    INTERACTION_AGREEMENT = 'interaction-agreement',

    /* Пользовательское соглашение */
    USER_AGREEMENT = 'user-agreement',

    /* Политика конфиденциальности сервиса */
    PRIVACY_POLICY = 'privacy-policy',

    /* Политика обработки персональных данных компании */
    DATA_PROCESSING_POLICY = 'data-processing-policy',

    /* Согласие на маркетинговые рассылки */
    MARKETING_COMMUNICATIONS_AGREEMENT = 'marketing-communications-agreement',

    /* Welcom Banner */
    WELCOM_BANNER = 'welcome-banner',
}
